import { OurWorkType } from "@/@types/types";
import { LazyImage } from "@/components/Helpers/LazyImage";
import { Link } from "gatsby";
import React from "react";
import * as styles from "./portfolio.module.css";

interface PortfolioProjectCardProps {
  work: OurWorkType;
  technologies?: string[];
  category?: string;
}

export const PortfolioProjectCard: React.FC<PortfolioProjectCardProps> = ({
  work,
  technologies = [],
  category = "",
}) => {
  const { title, description, links, icon, detailPage, techStack } = work;

  const hasPlayStore = !!links?.playStoreLink;
  const hasAppStore = !!links?.appStoreLink;
  const hasWebsite = !!links?.websiteLink;
  const techList = technologies.length ? technologies : techStack || [];
  const categoryLabel = category || work.category || "";

  return (
    <div className="col-lg-6 mb-5">
      <div className={`${styles.projectCard} d-flex flex-column`}>
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div>
            <h3 className="font-weight-bold mb-1 h4">{title}</h3>
            {categoryLabel && (
              <small
                className="text-uppercase font-weight-bold"
                style={{ color: "var(--text-muted)", fontSize: "0.7rem" }}
              >
                {categoryLabel}
              </small>
            )}
          </div>
          <div className="d-flex align-items-center">
            {hasAppStore && (
              <a
                href={links?.appStoreLink}
                className={`${styles.platformIcon} mr-2`}
                target="_blank"
                rel="noreferrer"
                title="Available on App Store"
              >
                <LazyImage
                  height={24}
                  width={24}
                  src="/images/app-store.svg"
                  alt="App Store"
                  classNameExtra="svg-icon"
                />
              </a>
            )}
            {hasPlayStore && (
              <a
                href={links?.playStoreLink}
                className={`${styles.platformIcon} mr-2`}
                target="_blank"
                rel="noreferrer"
                title="Available on Google Play"
              >
                <LazyImage
                  height={24}
                  width={24}
                  src="/images/google-play.svg"
                  alt="Google Play"
                  classNameExtra="svg-icon"
                />
              </a>
            )}
            {hasWebsite && (
              <a
                href={links?.websiteLink}
                className={styles.platformIcon}
                target="_blank"
                rel="noreferrer"
                title="Visit Website"
              >
                <LazyImage
                  height={24}
                  width={24}
                  src="/images/web.svg"
                  alt="Website"
                  classNameExtra="svg-icon"
                />
              </a>
            )}
          </div>
        </div>

        <div
          className="portfolio-bg shrink"
          style={{ display: "flex", justifyContent: "center", marginBottom: "2rem" }}
        >
          <LazyImage alt="app" height={255} width={255} src={icon?.file?.url || ""} />
        </div>

        <p style={{ color: "var(--text-muted)", fontSize: "0.9rem" }} className="mb-4">
          {description}
        </p>

        {techList.length > 0 && (
          <div className="mb-4">
            {techList.map((tech) => (
              <span key={tech} className={styles.techPill}>
                {tech}
              </span>
            ))}
          </div>
        )}

        {detailPage?.slug && (
          <Link to={detailPage.slug} className={styles.viewCaseLink}>
            View Case Study <span style={{ fontSize: "1rem", marginLeft: "4px" }}>→</span>
          </Link>
        )}
      </div>
    </div>
  );
};
